import { createSlice } from "@reduxjs/toolkit";
import { type RootStateI } from "../index";
import { useSelector } from "react-redux";
import { CustomPOSA_Javascript_DTO } from "@tootsweet/model/entities/saas/CustomPOSA";

export const useCustomPOSASelector = () => {
  return useSelector((state: RootStateI) => state.customPOSA.customPOSAs);
};

export interface CustomPOSAStateI {
  customPOSAs: CustomPOSA_Javascript_DTO[];
}

const initialState: CustomPOSAStateI = {
  customPOSAs: []
};

const customPOSASlice = createSlice({
  name: "customPOSA",
  initialState,
  reducers: {
    setCustomPOSAs: (state, action) => {
      state.customPOSAs = action.payload;
    },
    removeCustomPOSA: (state, action) => {
      state.customPOSAs = state.customPOSAs.filter(
        (posa) => posa.posaTypeId !== action.payload
      );
    }
  }
});

export default customPOSASlice.reducer;
export const { setCustomPOSAs, removeCustomPOSA } = customPOSASlice.actions;
